var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXMarkicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 4.71875L7.40625 8L10.6875 11.3125C11.0938 11.6875 11.0938 12.3438 10.6875 12.7188C10.3125 13.125 9.65625 13.125 9.28125 12.7188L6 9.4375L2.6875 12.7188C2.3125 13.125 1.65625 13.125 1.28125 12.7188C0.875 12.3438 0.875 11.6875 1.28125 11.3125L4.5625 8L1.28125 4.71875C0.875 4.34375 0.875 3.6875 1.28125 3.3125C1.65625 2.90625 2.3125 2.90625 2.6875 3.3125L6 6.59375L9.28125 3.3125C9.65625 2.90625 10.3125 2.90625 10.6875 3.3125C11.0938 3.6875 11.0938 4.34375 10.6875 4.71875Z",
    fill: "#037cb7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMarkicon);
export default __webpack_public_path__ + "static/media/X-mark icon.9d807683e123d4f0553ec50a8f1989aa.svg";
export { ForwardRef as ReactComponent };